import YaMapComponent from 'modules/App/components/YaMapComponent/YaMapComponent';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { startRequest as startGeocodingRequest } from 'modules/Contacts/redux/geocoding/actions';
import { createStructuredSelector } from 'reselect';
import { coordinatesByIdSelector, isMapLoadingSelector, isMapErrorSelector } from './selectors';

const mapStateToProps = createStructuredSelector({
  coordinates: coordinatesByIdSelector,
  isMapLoading: isMapLoadingSelector,
  isMapError: isMapErrorSelector,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCoordinates: (ymaps, id, address) => startGeocodingRequest(ymaps, id, address),
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(YaMapComponent);
